import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../css/Register.css';

function Register() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    institute: '',
    role: ''
  });
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [id]: value
    }));
  };

  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.name.trim()) newErrors.name = 'Name ist erforderlich';
    if (!formData.email.trim()) {
      newErrors.email = 'E-Mail ist erforderlich';
    } else if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
      newErrors.email = 'Ungültige E-Mail-Adresse';
    }
    if (!formData.institute.trim()) newErrors.institute = 'Institut ist erforderlich';
    if (!formData.role) newErrors.role = 'Benutzerrolle ist erforderlich';
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (validateForm()) {
      console.log('Formular eingereicht:', formData);
      navigate('/registration-success');
    } else {
      console.log('Formular enthält Fehler');
    }
  };

  return (
    <div className="register-container">
      <div className="register-card">
        <h1 className="register-title">Konto erstellen</h1>
        <p className="register-subtitle">Bitte füllen Sie Ihre Daten aus</p>
        
        <form onSubmit={handleSubmit} className="register-form" noValidate>
          <div className="form-group">
            <label htmlFor="name">Vollständiger Name</label>
            <input 
              type="text" 
              id="name" 
              placeholder="Ihr Name" 
              value={formData.name}
              onChange={handleChange}
              className={errors.name ? 'error' : ''}
            />
            {errors.name && <span className="error-message">{errors.name}</span>}
          </div>

          <div className="form-group">
            <label htmlFor="email">E-Mail</label>
            <input 
              type="email" 
              id="email" 
              placeholder="Ihre E-mail" 
              value={formData.email}
              onChange={handleChange}
              className={errors.email ? 'error' : ''}
            />
            {errors.email && <span className="error-message">{errors.email}</span>}
          </div>
          
          <div className="form-group">
            <label htmlFor="institute">Institut/Schule</label>
            <input 
              type="text" 
              id="institute" 
              placeholder="Name des Instituts" 
              value={formData.institute}
              onChange={handleChange}
              className={errors.institute ? 'error' : ''}
            />
            {errors.institute && <span className="error-message">{errors.institute}</span>}
          </div>
          
          <div className="form-group">
            <label htmlFor="role">Ich registriere mich als</label>
            <select 
              id="role" 
              value={formData.role}
              onChange={handleChange}
              className={errors.role ? 'error' : ''}
            >
              <option value="">Bitte auswählen</option>
              <option value="teacher">Lehrkraft</option>
              <option value="parent">Elternteil</option>
            </select>
            {errors.role && <span className="error-message">{errors.role}</span>}
          </div>
          
          <button type="submit" className="register-button">Konto erstellen</button>
        </form>
        
        <div className="register-footer">
          <p>Bereits ein Konto? <Link to="/login" className="login-link">Hier anmelden</Link></p>
        </div>
      </div>
    </div>
  );
}

export default Register;